import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0D2B4E] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
          {/* Company Info */}
          <div className="space-y-3 sm:space-y-4">
            <div className="flex flex-col gap-3">
              <img
                src="https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/c496e7b7b0d35cec41af6fd81216106e.png"
                alt="IGM Facility Service Banner"
                className="h-8 sm:h-10 w-auto object-contain object-left"
              />
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              Ihr zuverlässiger Partner für professionelle Gebäudereinigung, Hausmeisterservice und Schlüsseldienst.
            </p>
            <div className="flex items-center space-x-3">
              <a href="https://www.facebook.com/igmfacilityservice/" target="_blank" rel="nofollow noopener noreferrer" className="w-11 h-11 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.instagram.com/igmfacilityservice/" target="_blank" rel="nofollow noopener noreferrer" className="w-11 h-11 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-11 h-11 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-white/70 hover:text-white transition-colors inline-block py-1">Startseite</Link></li>
              <li><Link to="/leistungen" className="text-sm text-white/70 hover:text-white transition-colors inline-block py-1">Leistungen</Link></li>
              <li><Link to="/hausmeister" className="text-sm text-white/70 hover:text-white transition-colors inline-block py-1">Hausmeister</Link></li>
              <li><Link to="/schluesseldienst" className="text-sm text-white/70 hover:text-white transition-colors inline-block py-1">Schlüsseldienst</Link></li>
              <li><Link to="/jobs" className="text-sm text-white/70 hover:text-white transition-colors inline-block py-1">Jobs</Link></li>
              <li><Link to="/kontakt" className="text-sm text-white/70 hover:text-white transition-colors inline-block py-1">Kontakt</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Dienstleistungen</h3>
            <ul className="space-y-2">
              <li className="text-sm text-white/70 py-1">Gebäudereinigung</li>
              <li className="text-sm text-white/70 py-1">Hausmeisterservice</li>
              <li className="text-sm text-white/70 py-1">Schlüsseldienst 24/7</li>
              <li className="text-sm text-white/70 py-1">Fensterreinigung</li>
              <li className="text-sm text-white/70 py-1">Winterdienst</li>
              <li className="text-sm text-white/70 py-1">Umzugsreinigung</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-lg mt-0.5 text-white/70 flex-shrink-0"></i>
                <span className="text-sm text-white/70">Industriestr. 37, 40878 Ratingen</span>
              </li>
              <li className="flex items-center space-x-3 min-h-[44px]">
                <i className="ri-phone-line text-lg text-white/70 flex-shrink-0"></i>
                <a href="tel:+492102739807" className="text-sm text-white/70 hover:text-white transition-colors">02102 7398070</a>
              </li>
              <li className="flex items-center space-x-3 min-h-[44px]">
                <i className="ri-mail-line text-lg text-white/70 flex-shrink-0"></i>
                <a href="mailto:info@igmfacilityservice.de" className="text-sm text-white/70 hover:text-white transition-colors break-all">info@igmfacilityservice.de</a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-line text-lg mt-0.5 text-white/70 flex-shrink-0"></i>
                <span className="text-sm text-white/70">Mo-Fr: 10:00 - 15:00<br />Sa: 12:00 - 15:00<br />Notdienst: 24/7</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 sm:mt-12 pt-6 sm:pt-8 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-sm text-white/50 text-center md:text-left">© 2021 IGM Facility Service. Alle Rechte vorbehalten.</p>
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
            <Link to="/impressum" className="text-sm text-white/50 hover:text-white transition-colors min-h-[44px] flex items-center">Impressum</Link>
            <Link to="/datenschutz" className="text-sm text-white/50 hover:text-white transition-colors min-h-[44px] flex items-center">Datenschutz</Link>
            <Link to="/agb" className="text-sm text-white/50 hover:text-white transition-colors min-h-[44px] flex items-center">AGB</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}